import i from "./index405.js";
import { resolveComponent as l, createElementBlock as t, openBlock as e, createVNode as n, Transition as p, withCtx as m, createCommentVNode as s } from "vue";
import d from "./index231.js";
const u = ["data-component"], f = {
  key: 0,
  class: "mr-15"
};
function b(o, r, w, y, _, h) {
  const a = l("ms-arrow-top");
  return e(), t("div", {
    "data-component": o.$options.name,
    class: "sticky bottom-0 z-content-dropdown"
  }, [
    n(p, {
      "enter-from-class": "opacity-0",
      "enter-to-class": "opacity-100",
      "leave-from-class": "opacity-100",
      "leave-to-class": "opacity-0",
      duration: 300
    }, {
      default: m(() => [
        o.visible ? (e(), t("button", {
          key: 0,
          class: "absolute flex items-center justify-center transition-opacity bg-white border border-solid rounded shadow cursor-pointer z-content-swimminglink screen-l:w-auto screen-l:p-10 border-color-neutral-black h-50 w-50 right-10 bottom-10",
          type: "button",
          onClick: r[0] || (r[0] = (...c) => o.scrollTop && o.scrollTop(...c))
        }, [
          o.isScreenL ? (e(), t("span", f, "Nach oben")) : s("", !0),
          n(a, { class: "w-24 h-24 color-anthracite" })
        ])) : s("", !0)
      ]),
      _: 1
    })
  ], 8, u);
}
const $ = /* @__PURE__ */ d(i, [["render", b]]);
export {
  $ as default
};
